module.exports = __webpack_public_path__ + "static/sign-up-form-1-4-b518996678fc633d514bb4d75a75033a.png";